import React from 'react'
import './Experience.css'

const Experience = () => {
  return (
    <div className='Head' id='Experience'><h1 id='heading'>Education</h1>
    <div className="experience">
        
    <div className="achievement">
        <div className="circle">75.68 %</div>
        <span>SSC</span>
        <span>2017</span>
    </div>

    <div className="achievement">
        <div className="circle">65.54 %</div>
        <span>HSC</span>
        <span>2019</span>
    </div>
    <div className="achievement">
        <div className="circle">74.49 %</div>
        <span>BCS GRADUATE</span>
        <span>2022</span>
    </div>
    </div>
    </div>
  )
}

export default Experience